import canonical from '../config/site-metadata.canonical.json';

const OG_WIDTH = 1200;
const OG_HEIGHT = 630;
const TW_WIDTH = 600;
const TW_HEIGHT = 314;

/**
 * When true, {@link Page} uses repo canonical title/description/share images on every route,
 * overriding per-page SEO. Set in deployment env: REACT_APP_FORCE_CANONICAL_SITE_METADATA=true
 */
export const isForceCanonicalSiteMetadataEnabled = () =>
  process.env.REACT_APP_FORCE_CANONICAL_SITE_METADATA === 'true';

/**
 * @param {object} raw - Parsed site-metadata.canonical.json (title, description, ogImageUrl, twitterImageUrl)
 * @returns {{ title: string, description: string, socialSharing: object }}
 */
export const normalizeCanonicalToPageMeta = raw => {
  const title = (raw && raw.title) || '';
  const description = (raw && raw.description) || '';
  const ogUrl = (raw && raw.ogImageUrl) || '';
  const twUrl =
    (raw && raw.twitterImageUrl != null && raw.twitterImageUrl !== '' ? raw.twitterImageUrl : ogUrl) ||
    '';

  const socialSharing = {
    title,
    description,
    images1200: ogUrl
      ? [{ name: 'facebook', url: ogUrl, width: OG_WIDTH, height: OG_HEIGHT }]
      : [],
    images600: twUrl
      ? [{ name: 'twitter', url: twUrl, width: TW_WIDTH, height: TW_HEIGHT }]
      : [],
  };

  return { title, description, socialSharing };
};

/**
 * Metadata from src/config/site-metadata.canonical.json in the shape Page expects for forced mode.
 */
export const getCanonicalPageMeta = () => normalizeCanonicalToPageMeta(canonical);
